module.exports = __webpack_public_path__ + "static/gold-76dca11e36ac9babe8484c6b0f959c5b.svg";